var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from 'reselect';
import { CLEAR_NUMBERS_LOADED_STATE, GET_NUMBERS_SUCCESS, GET_PRICING_NUMBERS_SUCCESS, ORDER_INITIAL_NUMBER, ORDER_INITIAL_NUMBER_FAILURE, ORDER_INITIAL_NUMBER_SUCCESS, SET_AVAILABLE_NUMBER_TYPES } from './pricing-numbers.action';
export var initialState = {
    documents: null,
    pricing: [],
    numbers: [],
    areNumbersLoaded: false,
    availableTypes: [],
    orderingInitialNumber: false,
};
export function pricingNumbersReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_PRICING_NUMBERS_SUCCESS:
            var payload = action.payload;
            return __assign({}, state, { documents: payload.documents, pricing: payload.pricing, numbers: [], areNumbersLoaded: false });
        case CLEAR_NUMBERS_LOADED_STATE:
            return __assign({}, state, { areNumbersLoaded: false });
        case GET_NUMBERS_SUCCESS:
            return __assign({}, state, { numbers: action.payload, areNumbersLoaded: true });
        case SET_AVAILABLE_NUMBER_TYPES:
            return __assign({}, state, { availableTypes: action.payload });
        case ORDER_INITIAL_NUMBER:
            return __assign({}, state, { orderingInitialNumber: true });
        case ORDER_INITIAL_NUMBER_SUCCESS:
        case ORDER_INITIAL_NUMBER_FAILURE:
            return __assign({}, state, { orderingInitialNumber: false });
        default: {
            return state;
        }
    }
}
export var getPricing = function (state) { return state.pricing; };
export var getNumbers = function (state) { return state.numbers; };
export var getAreNumbersLoaded = function (state) { return state.areNumbersLoaded; };
export var getAvailableTypes = function (state) { return state.availableTypes; };
export var getDocuments = function (state) { return state.documents; };
export var getOrderingInitialNumber = function (state) { return state.orderingInitialNumber; };
export var getMainPricingNumberSelector = function (state) { return state.pricingNumbers; };
export var getPricingSelector = createSelector(getMainPricingNumberSelector, getPricing);
export var getNumbersSelector = createSelector(getMainPricingNumberSelector, getNumbers);
export var getAreNumbersLoadedSelector = createSelector(getMainPricingNumberSelector, getAreNumbersLoaded);
export var getAvailableTypesSelector = createSelector(getMainPricingNumberSelector, getAvailableTypes);
export var getDocumentsSelector = createSelector(getMainPricingNumberSelector, getDocuments);
export var getOrderingInitialNumberSelector = createSelector(getMainPricingNumberSelector, getOrderingInitialNumber);
